/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const feedTranslationItemSchema = z.object({
  challengeId: z.number().int(),
  lang: z.string(),
  title: z.string().nullable(),
  definition: z.string(),
  usageNote: z.string().nullable(),
  examples: z.string().nullable(),
});

export type IFeedTranslationItem = z.infer<typeof feedTranslationItemSchema>;

export const getFeedTranslationsResponseDataSchema = z.array(feedTranslationItemSchema);

export type IGetFeedTranslationsResponseData = z.infer<
  typeof getFeedTranslationsResponseDataSchema
>;

export const getFeedTranslationsResponseSchema = createApiResponseSchema(
  getFeedTranslationsResponseDataSchema,
) as z.ZodSchema<IAPI<IGetFeedTranslationsResponseData>>;

export type IGetFeedTranslationsResponse = IAPI<IGetFeedTranslationsResponseData>;
